'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Headphones = require('./Headphones');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Headphones).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Headphones/index.js
// module id = 1202
// module chunks = 1